import React from "react";
import "./FleetContext.css";

// The caller supplies the existing selection; this heading owns no selection state.
export default function FleetSelectionHeading({ row, title, detail = "", inlineIdentity = false }) {
  const driverLabel = row?.driverLabel === "Chauffeur non renseigné" ? "" : row?.driverLabel;
  const secondaryLabel = [inlineIdentity ? "" : driverLabel, detail].filter(Boolean).join(" · ");
  return (
    <div className="fleet-selection-heading" data-fleet-selection-heading={title}>
      <h3 className="m-0 text-[0.98rem] font-bold leading-tight text-text">
        {inlineIdentity ? <>
          <span className="whitespace-nowrap">{row?.truckLabel}</span>
          {driverLabel ? <> <span className="ml-1 text-[0.72rem] font-normal text-content-copy">{driverLabel}</span></> : null}
        </> : <>{title}{row?.truckLabel ? <> · <span>{row.truckLabel}</span></> : null}</>}
      </h3>
      {secondaryLabel ? <p className="m-0 text-[0.72rem] leading-tight text-content-copy">{secondaryLabel}</p> : null}
    </div>
  );
}
